import {View} from "@lernetz/ts-lib"
import template from "./metainfos.component.html";
import downloadTemplate from "./downloads/download.component.html";
import linkTemplate from "./downloads/link.component.html";

export class MetaInfos extends View {
    constructor() {
        super({ template });
        this.registry.add('App\\Download', () => new View({ template: downloadTemplate}));
        this.registry.add('App\\Link', () => new View({ template: linkTemplate}));
    }
}
